import React, { useContext } from 'react';

import TargetContext from './TargetContext';
import { timeSort } from '../utils/dataUtils';
import { ascendingValueSort } from '../reducers/data';
import { parseDate } from '../utils/formats';
import { getHighGlucoseAreaForDay, getLowGlucoseAreaForDay } from '../utils/svgUtils';
import './Dashboard.css';

function Day({ active, day, dayName, data, glucosePath, onClick, timeScale }) {
  const { targets } = useContext(TargetContext);
  const date = parseDate(day) || undefined;

  const dataForDay = (data[day] || []).sort(ascendingValueSort);
  const highArea = (dataForDay.length && date) ? getHighGlucoseAreaForDay({ day: date, targets, timeScale })(dataForDay) : '';
  const lowArea = (dataForDay.length && date) ? getLowGlucoseAreaForDay({ day: date, targets, timeScale })(dataForDay) : '';

  const translateX = date ? -timeScale({ time: date.toISOString() }) : 0;
  const svg = (
    <div className="svgContainer">
      <svg
        viewBox="75 20 720 350"
        preserveAspectRatio="xMidYMin meet"
        shapeRendering="crispEdges"
        className={`${onClick ? 'interactive ' : ''}${active ? '' : 'inactive '}${dayName}`}
      >
        <g transform="translate(75, 20)">
          <path className="sensor area over" d={highArea} transform={`translate(${translateX},0)`} shapeRendering="auto" />
          <path className="sensor area below" d={lowArea} transform={`translate(${translateX},0)`} shapeRendering="auto" />
          <rect className="target" x="-2" y={350 - targets.top} width="724" height={targets.top - targets.bottom} />
          {glucosePath
          ? <path className="sensor line" d={glucosePath} transform={`translate(${translateX},0)`} shapeRendering="auto" />
          : undefined
          }
        </g>
      </svg>
    </div>
  );
  return (
    onClick
      ? (
        <button
          tabIndex="0"
          onClick={onClick}
          onSelect={onClick}
        >
          {svg}
        </button>
      )
      : (
        svg
      )
  );
}


export default Day;
